.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  user-select: none;
}

.logo {
  --slide-distance: -100%;
  --transition-duration: 0.8s;
  composes: slideDown from global;
}

.select {
  --slide-distance: -90%;
  --transition-duration: 0.8s;
  composes: slideDown from global;
}

.cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 600px;
  gap: 1rem;
  --slide-distance: -15%;
  --transition-duration: 0.8s;
  composes: slideDown from global;
}

.card {
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 240px;
  height: 125px;
  text-align: center;
  color: rgb(100, 100, 100);
  background-color: rgb(250, 250, 250);
  border-radius: 5px;
  border: 1px solid var(--border-grey);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}
.card:hover {
  background-color: rgb(240, 240, 240);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 1);
  color: black;
  transform: scale(1.05);
}

.title {
  font-family: Gantari;
  font-size: 23px;
  font-style: normal;
  font-weight: 600;
}
